import type { AsyncSequence } from "#public"
import type { Sequence } from "#public"

import { Channel } from "../classes/Channel"
import { Map } from "../functions/Map"
import { ProcessIterable } from "./ProcessIterable"
import { WaitPromises } from "./WaitPromises"

export function JoinConcurrent<T>(...arrays: AsyncGenerator<AsyncGenerator<T>>[]): AsyncGenerator<T>
export function JoinConcurrent<T>(...arrays: AsyncGenerator<AsyncSequence<T>>[]): AsyncGenerator<T>
export function JoinConcurrent<T>(...arrays: Sequence<AsyncSequence<T>>[]): AsyncGenerator<T>
export function JoinConcurrent<T>(...arrays: AsyncSequence<AsyncSequence<T>>[]): AsyncGenerator<T> {
  const { push, stop, stream } = Channel<T>()

  const promises = Map(iterable => {
    const inner: Promise<void>[] = []
    return ProcessIterable(iterable, sequence => {
      inner.push(ProcessIterable(sequence, push))
    }).then(() => WaitPromises(inner))
  }, arrays)

  void WaitPromises(promises).then(() => stop(undefined), stop)

  return stream
}
